import React, { useCallback, useContext } from 'react';
import { FindAndReplace } from '../types';
import Typography from '../../../../../kingpin/atoms/Typography';
import { Link } from 'react-router-dom';
import Divider from '../../../../../components/Common/Card/Divider';
import { PortalsContext } from '../../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider';
import ReportGadgetsContext from '../../../../../contexts/ReportGadgetsContext';
import {
  buildDashboardShow,
  buildShowBoard,
  buildShowGlobalGoal,
  buildShowGlobalKpiList,
} from '../../../../../navigation/appRoutes';
import useFindDashboardByGadgetId from './useFindDashboardByGadgetId';

const ReceiptItem = ({
  type,
  contentDetailsList,
}: {
  type:
    | 'Goals'
    | 'Boards'
    | 'Scorecards'
    | 'Dashboard Gadgets'
    | 'Chart Definitions';
  contentDetailsList: FindAndReplace.AffectedContentDetails[];
}) => {
  const { selectedPortal } = useContext(PortalsContext);
  const { reportGadgetsLookup } = useContext(ReportGadgetsContext);
  const findDashboardByGadgetId = useFindDashboardByGadgetId();

  const getLink = useCallback(
    (id: string): string | undefined => {
      switch (type) {
        case 'Goals':
          return buildShowGlobalGoal(id);
        case 'Boards':
          return buildShowBoard(id);
        case 'Scorecards':
          return buildShowGlobalKpiList({
            scorecardId: id,
            portal: selectedPortal,
          });
        case 'Dashboard Gadgets':
          const dashboard = findDashboardByGadgetId(id);
          if (!dashboard) return undefined;
          return buildDashboardShow({
            id: dashboard.id,
            portal: selectedPortal,
          });
        case 'Chart Definitions':
          const definition = reportGadgetsLookup[id]?.chartDef;
          if (!definition) return undefined;
          return undefined;
        default:
          const e = new Error(
            `Missing gadget type for id ${id}, type: ${type}`,
          );
          e.name = "ReceiptItem: can't build link";
          throw e;
      }
    },
    [reportGadgetsLookup, findDashboardByGadgetId, selectedPortal, type],
  );
  if (!contentDetailsList?.length) return null;

  return (
    <>
      <Divider />
      <Typography.Header type={'H4'}>
        {type} ({contentDetailsList.length.toString()})
      </Typography.Header>
      {contentDetailsList.map((item) => (
        <Typography.Body key={item.id} type="Body 13">
          <Link
            style={{ display: 'block' }}
            to={getLink(item.id) || ''}
            target={'_blank'}
          >
            {item.name || item.id}
          </Link>
        </Typography.Body>
      ))}
    </>
  );
};

export default ReceiptItem;
